export class ManagerDetails { 
    phoneNumber: string;
    email: string;
    name: string;
}